// 🧬 B247 (AI_111) — Campo de entrada de AUTOANTICORPO (Fase 2b). Renderiza o
// controle certo conforme o tipo (fonte: normalizarSorologia):
//  • título (FAN/ASMA/anti-LKM1/AMA) → texto com sugestões 1/40…1/1280 (datalist)
//  • padrão (ANCA) → lista Negativo / c-ANCA / p-ANCA / ANCA atípico
//  • numérico (anti-transglutaminase, anti-DNA) → número
// A padronização final acontece no GRAVAR (padronizarRegistroMarcadores); por isso
// o título mostra o valor cru enquanto se digita (não brigar com a digitação).
import React from "react";
import { theme } from "../../../shared/styles/theme";
import {
  TIPO_AUTOANTICORPO,
  OPCOES_ANCA,
  TITULOS_AUTOANTICORPO,
  normalizarPadraoANCA,
} from "../../sorologias/services/normalizarSorologia";

const controle: React.CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  border: `1px solid ${theme.gray[300]}`,
  borderRadius: theme.borderRadius.md,
  fontSize: "14px",
  fontFamily: theme.fonts.sans,
  boxSizing: "border-box",
  background: "white",
};

interface Props {
  campo: string;
  valor: string;
  onChange: (v: string) => void;
  placeholder?: string;
  desabilitado?: boolean;
}

export default function CampoAutoanticorpo({
  campo,
  valor,
  onChange,
  placeholder,
  desabilitado,
}: Props) {
  const tipo = TIPO_AUTOANTICORPO[campo];

  // ANCA → lista de padrões.
  if (tipo === "padrao") {
    const atual = normalizarPadraoANCA(valor) ?? "";
    return (
      <select
        style={controle}
        value={atual}
        disabled={desabilitado}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">—</option>
        {OPCOES_ANCA.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    );
  }

  // Título → texto com sugestões padrão (permite título fora da lista).
  if (tipo === "titulo") {
    const listId = `titulos-${campo}`;
    return (
      <>
        <input
          type="text"
          list={listId}
          style={controle}
          value={valor || ""}
          disabled={desabilitado}
          placeholder="ex.: 1/80 ou Negativo"
          onChange={(e) => onChange(e.target.value)}
        />
        <datalist id={listId}>
          {TITULOS_AUTOANTICORPO.map((t) => (
            <option key={t} value={t} />
          ))}
        </datalist>
      </>
    );
  }

  // Numérico (anti-transglutaminase, anti-DNA).
  return (
    <input
      type="number"
      style={controle}
      value={valor || ""}
      disabled={desabilitado}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
